import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-box",
  "use": "spr-box-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"spr-box\">\n\n<g>\n\t<g>\n\t\t<path fill=\"#FFFFFF\" d=\"M501.8,0.4H10.2C4.6,0.4,0,5,0,10.6v490.8c0,5.6,4.6,10.2,10.2,10.2h491.6c5.6,0,10.2-4.6,10.2-10.2V10.6\n\t\t\tC512,5,507.4,0.4,501.8,0.4z M491.6,491.2H20.4V20.8h471.2L491.6,491.2L491.6,491.2z\" />\n\t</g>\n</g>\n<path fill=\"#FFFFFF\" d=\"M436.2,65.6H75.4c-5.6,0-10.2,4.6-10.2,10.2v360.8c0,5.6,4.6,10.2,10.2,10.2h360.8c5.6,0,10.2-4.6,10.2-10.2\n\tV75.8C446.4,70.2,441.8,65.6,436.2,65.6z M426,86v69.7L356.3,86H426z M426,184.6v58L314.2,130.7c0,0,0,0,0,0L269.5,86h58L426,184.6z\n\t M240.7,86c0,0.1,0.1,0.1,0.1,0.2l37.6,37.6c0.7,0.7,147.6,147.6,147.6,147.6v55.2L185.4,86H240.7z M156.6,86L426,355.4V412L100,86\n\tH156.6z M85.6,426.4V357l69.4,69.4H85.6z M183.9,426.4l-98.3-98.3v-58.9l157.2,157.2H183.9z M271.6,426.4c-0.1-0.2-0.3-0.3-0.4-0.5\n\tL85.7,240.5c0,0-0.1-0.1-0.1-0.1v-55.1l241.2,241.2H271.6z M355.6,426.4L355.6,426.4c-0.1-0.1-0.2-0.2-0.3-0.4L85.6,156.4v-56\n\tl326,326H355.6z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ../img/sprite/box.svg
// module id = 303
// module chunks = 0